export default "__VITE_ASSET__DsB33OlY__"